import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLuxonDateModule } from '@angular/material-luxon-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer } from '@angular/platform-browser';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

const matModules = [
  MatCardModule,
  MatButtonModule,
  MatExpansionModule,
  MatInputModule,
  MatCheckboxModule,
  MatExpansionModule,
  MatIconModule,
  MatSnackBarModule,
  MatToolbarModule,
  MatSidenavModule,
  MatListModule,
  MatBadgeModule,
  MatTooltipModule,
  MatTabsModule,
  MatDialogModule,
  MatExpansionModule,
  MatSelectModule,
  MatDatepickerModule,
  MatLuxonDateModule,
  MatChipsModule,
  MatProgressSpinnerModule,
  MatButtonToggleModule,
  MatStepperModule,
  MatSlideToggleModule,
  MatAutocompleteModule,
  MatExpansionModule,
  MatMenuModule,
  MatGridListModule,
  MatPaginatorModule,
  MatSortModule,
  MatTableModule,
  MatRadioModule,
  MatSliderModule,
  NgxMaterialTimepickerModule,
  MatProgressBarModule,
  PdfViewerModule,
];

@NgModule({
  declarations: [],
  imports: [CommonModule, ...matModules],
  exports: [...matModules],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        display: {
          dateInput: 'DD',
          monthYearLabel: 'LLL yyyy',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM yyyy',
        },
      },
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class MaterialModule {
  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
  ) {
    this.iconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl('assets/mdi.svg'));
    this.iconRegistry.addSvgIcon('google-logo', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/google-flat.svg'));
    this.iconRegistry.addSvgIcon('facebook-logo', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/facebook-flat.svg'));
    this.iconRegistry.addSvgIcon('switch-camera', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/switch-camera.svg'));
    this.iconRegistry.addSvgIcon('visa', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/payments/visa.svg'));
    this.iconRegistry.addSvgIcon('mastercard', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/payments/mastercard.svg'));
    this.iconRegistry.addSvgIcon('maestro', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/payments/maestro.svg'));
    this.iconRegistry.addSvgIcon('amex', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/payments/amex.svg'));
  }
}
